import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Container, Row } from 'reactstrap';
import AddNewApiKeyForm from './AddNewApiKeyForm/AddNewApiKeyForm';
import { postLeadApiResource } from '../../../../../utils/api';
import CustomModal from '../../../../../shared/components/customComponents/CustomModal/CustomModal';
import ApiKeyRevealModal from '../ApiKeyRevealModal';

const AddNewApiKey = () => {
  const navigate = useNavigate();
  const authUser = useSelector(state => state.auth.user);
  const [createdApiKey, setCreatedApiKey] = useState(null);
  const [revealModal, setRevealModal] = useState(false);
  const [failedAddedModal, setFailedAddedModal] = useState(false);
  const [messageAddedError, setMessageAddedError] = useState('');

  const handleSubmit = (value) => {
    postLeadApiResource(value, authUser.accessToken).then(res => {
      if (res.data.success) {
        setCreatedApiKey(res.data.data.api_key);
        setRevealModal(true);
      } else {
        setMessageAddedError(res.data.errors[0].message);
        setFailedAddedModal(!failedAddedModal);
      }
    })
  }

  return (
    <Container>
      <Row>
        <AddNewApiKeyForm onSubmit={handleSubmit} />
      </Row>

      <ApiKeyRevealModal
        modal={revealModal}
        toggle={() => {
          setRevealModal(!revealModal);
          navigate('/settings/integrations');
        }}
        apiKey={createdApiKey}
        title="Resource added, API key generated"
      />
      <CustomModal
        successModal={failedAddedModal}
        toggleCloseModal={() => setFailedAddedModal(!failedAddedModal)}
        textModal={messageAddedError}
        color={"danger"}
      />
    </Container>
  );
};

export default AddNewApiKey;
